import sendLocalRequest from "./sendLocalRequest";

export const getSerialNumberRecord = (auth_token, uniqueId) => {
    return  new Promise( (resolve, reject) => {
        sendLocalRequest(`machines/${uniqueId}/serial_number_record`, "GET", auth_token).then( (data) => {
            resolve(data);
        }).catch( (error) => {
            reject(error);
        })
    });



};
